import { analytics as swipeclockAnalytics } from 'swipeclock-frontend';
import freeTrial from './freeTrial';

const analytics = {
  ...swipeclockAnalytics,
  freeTrial,
};

export { analytics };
